<template>
  <div class="columns">
    <div class="column is-three-quarters ">
      <admin-section-header icon="arrow-up" :title="$t('EcobankaTV')" />
       <iframe
          width="100%"
          style="height: 50%;"
          src="https://www.youtube.com/embed/videoseries?list=PL3DOb74zZ2pOS2wc4GdEkL1c7fW3E0KTz"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          class="tile is-child"
        ></iframe>
    </div>
    <div class="column is-one-quarter twitter">
      <TwitterFeed profile="bopinion" />
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import AdminSectionHeader from '@/components/admin/dasboard/AdminSectionHeader.vue'
import TwitterFeed from '@/components/admin/dasboard/TwitterFeed.vue'

export default {
  components: { TwitterFeed, AdminSectionHeader },
  mounted() {},
  data() {
    return {}
  },
  methods: {
    ...mapActions('onBoard', ['getOnboardRequests'])
  }
}
</script>

<style scoped>
.columns {
  margin-top: 0;
  overflow: hidden;
}
.column.twitter,
.solicitudes-table {
  overflow: scroll;
}
</style>
